// extracted by mini-css-extract-plugin
export default {"bottomBar":"bottomBar-c0468479","buttons":"buttons-bcbc28e1","bodyHead":"bodyHead-aef53a23","padding":"padding-ba437b0e","title":"title-ae5f6dab"};